// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressNc_v-icon_28nSc","nsAddressForm":"NsAddressNc_nsAddressForm_13LiO","dualColumn":"NsAddressNc_dualColumn_1aWdE","firstCol":"NsAddressNc_firstCol_y_d17"};